import { render, staticRenderFns } from "./adminPage.vue?vue&type=template&id=29fb7f26&scoped=true&"
import script from "./adminPage.vue?vue&type=script&lang=js&"
export * from "./adminPage.vue?vue&type=script&lang=js&"
import style0 from "./adminPage.vue?vue&type=style&index=0&id=29fb7f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb7f26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VApp,VBtn,VCard,VContainer,VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemSubtitle})
